import React, { useContext } from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";
import { makeStyles } from "@material-ui/styles";
import AppBar from "@material-ui/core/AppBar";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Toolbar from "@material-ui/core/Toolbar";
import Login from "../login";
import { AppContext, TOGGLE_MENU } from "../../Context";
import { THEME } from "../../Actions/stateActions";
import Profile from "./Profile";
import { UnstyledButton } from "@mantine/core";
import { useHistory } from "react-router-dom";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: theme.app.background[1],
    color: theme.app.color,
    boxShadow: "none",
    borderBottom: `1px solid ${theme.app.borderColor}`,
    zIndex: theme.zIndex.drawer + 1,
    padding: "0 0 0 16px",
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    "@media(max-width: 600px)": {
      marginLeft: 0,
      width: "100%",
    },
  },
  toolbar: {
    padding: 0,
    "@media(max-width: 600px)": {
      padding: 0,
      minHeight: "64px",
    },
  },
  menuButton: {
    padding: "4px",
    marginRight: "32px",
    "@media(max-width: 600px)": { display: "none" },
  },
  hide: {
    display: "none",
  },
  buttonIcon: {
    color: theme.app.labelColor,
  },
  nav: {
    flexGrow: 1,
  },
  unpaid: {
    backgroundColor: theme.app.dangerColor,
    color: theme.app.labelColor,
  },
  paid: {
    backgroundColor: theme.app.infoColor,
    color: theme.app.labelColor,
  },
  button: {
    color: theme.app.labelColor,
    padding: "4px",
    borderRadius: "50%",
    transition: theme.transitions.create(["background-color"], {
      duration: theme.transitions.duration.short,
      easing: theme.transitions.easing.easeInOut,
    }),
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  logoContainer: {
    alignItems: "center",
    display: "flex",
  },
  logoImg: {
    height: "var(--logo-height)",
    width: "var(--logo-width)",
    "@media (max-width: 667px)": {
      height: "var(--logo-height-xs)",
      width: "var(--logo-width-xs)",
    },
  },
}));

const Header = ({ whoami }) => {
  const classes = useStyles();
  const context = useContext(AppContext);
  const { dispatch, state } = context;
  const toggleMenu = () => dispatch({ type: TOGGLE_MENU });
  const { config, language, theme } = useSelector((state) => ({
    config: state.config,
    language: state.language,
    theme: state.cookies[THEME],
  }));

  const history = useHistory()

  const logoSrc = () => {
    if (config.logo) {
      return config.logo.src;
    }
    if (theme === "light") {
      return "/ee-static/booking/logo.svg";
    }
    return "/ee-static/booking/logo_dark.svg";
  };
  return (
    <AppBar
      position="absolute"
      className={classNames(
        classes.appBar,
        state.menuOpen && classes.appBarShift
      )}
    >
      <a href="#main-page-content" id="main-content-link">{language.SkipToMainContent}</a>
      <Toolbar disableGutters={state.menuOpen} className={classes.toolbar}>
        <IconButton
          className={classNames(
            classes.menuButton,
            state.menuOpen && classes.hide
          )}
          onClick={toggleMenu}
          aria-label={language.toggleMenu}
        >
          <MenuIcon className={classes.buttonIcon} />
        </IconButton>
        <UnstyledButton onClick={() => history.push("/")} className={classes.logoContainer} aria-label={language.backToHomepage}>
          <img src={logoSrc()} className={classes.logoImg} alt="logo" />
        </UnstyledButton>
        <div className={classes.nav} />

        <Login />
        <Profile whoami={whoami} />
      </Toolbar>
    </AppBar>
  );
};

export default Header;
